/**
 * Estado de filtros da aba Pesquisas (Surveys) do Dashboard.
 */

export const EMPTY_SURVEYS_FILTER_STATE = {
  channel: "",
  ids_origens: [],
  labels: {
    channels: {},
    origins: {},
  },
};

function toPositiveIntArray(raw) {
  const list = Array.isArray(raw) ? raw : raw != null && raw !== "" ? String(raw).split(",") : [];
  const out = [];
  const seen = new Set();
  for (const item of list) {
    const n = Number(String(item ?? "").trim());
    if (!Number.isFinite(n) || n <= 0 || seen.has(n)) continue;
    seen.add(n);
    out.push(n);
  }
  return out;
}

function normalizeLabels(map) {
  if (!map || typeof map !== "object") return {};
  const out = {};
  for (const [k, v] of Object.entries(map)) {
    const id = String(k).trim();
    const label = String(v ?? "").trim();
    if (!id || !label) continue;
    out[id] = label;
  }
  return out;
}

export function normalizeSurveysFilterState(raw) {
  const s = raw && typeof raw === "object" ? raw : {};
  const labels = s.labels && typeof s.labels === "object" ? s.labels : {};
  return {
    channel: String(s.channel || "").trim().toLowerCase(),
    ids_origens: toPositiveIntArray(s.ids_origens),
    labels: {
      channels: normalizeLabels(labels.channels),
      origins: normalizeLabels(labels.origins),
    },
  };
}

export function countSurveysFilterCriteria(state) {
  const s = normalizeSurveysFilterState(state);
  let n = 0;
  if (s.channel) n += 1;
  if (s.ids_origens.length) n += 1;
  return n;
}

export function surveysFilterStateToAnalyticsParams(state) {
  const s = normalizeSurveysFilterState(state);
  const params = {};
  if (s.channel) params.channel = s.channel;
  if (s.ids_origens.length) params.originId = s.ids_origens[0];
  return params;
}

export function buildSurveysFilterSummaries(state, t) {
  const s = normalizeSurveysFilterState(state);
  const items = [];
  const tr = (key, fallback, vars) =>
    t(`dashboardPage.surveysFilters.${key}`, { defaultValue: fallback, ...vars });

  if (s.channel) {
    const label = s.labels.channels[s.channel] || s.channel;
    items.push({
      key: `channel:${s.channel}`,
      label,
      title: tr("chipChannelTooltip", "Canal: {{value}}", { value: label }),
      tone: "emphasis",
    });
  }

  s.ids_origens.forEach((id) => {
    const label = s.labels.origins[String(id)] || `#${id}`;
    items.push({
      key: `origem:${id}`,
      label,
      title: tr("chipOriginTooltip", "Origem do lead: {{value}}", { value: label }),
    });
  });

  return items;
}
